module.exports = __webpack_public_path__ + "assets/img/webRadar.fe415961.png";